import { render } from "./Ellipsis.vue?vue&type=template&id=5590106c"
const script = {}

import "./Ellipsis.vue?vue&type=style&index=0&id=5590106c&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__